export function prepareSearchQueryForEngine(searchQuery: any) {
  if (searchQuery === null) {
    return searchQuery;
  }
  const newSearchQuery = { ...searchQuery };
  delete newSearchQuery.offset;
  delete newSearchQuery.limit;
  return newSearchQuery;
}
